export default "__VITE_ASSET__CBsGaLVU__"